import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../shared/routing/routes';
import { DrawAHeartCommitment } from './components/DrawAHeartCommitment';
import { DrawAHeartIntro } from './components/DrawAHeartIntro';
import { DrawAHeartReady } from './components/DrawAHeartReady';
import { useOnboardingStore } from './hooks/useOnboardingStore';

export const DrawAHeart = () => {
    const navigate = useNavigate();
    const [currentState, setCurrentState] = useState(0);
    const [disableButton, setDisableButton] = useState(true);
    const setCurrentStep = useOnboardingStore(state => state.setCurrentStep);

    const onboardingStep = 3;
    useEffect(() => {
        setCurrentStep(onboardingStep);
    }, [setCurrentStep]);

    const handleContinue = async () => {
        setDisableButton(true);
        const newState = currentState + 1;
        setCurrentStep(onboardingStep + newState);
        if (newState > 2) {
            navigate(ROUTES.onboarding.ocdThemesSelection);
        } else {
            setCurrentState(newState);
        }
    };

    const handleSpeechBubbleComplete = () => {
        setDisableButton(false);
    };

    const renderCurrentState = () => {
        switch (currentState) {
            case 0:
                return (
                    <DrawAHeartIntro
                        onContinue={handleContinue}
                        isDisabled={disableButton}
                        onSpeechBubbleComplete={handleSpeechBubbleComplete}
                    />
                );
            case 1:
                return (
                    <DrawAHeartCommitment
                        onContinue={handleContinue}
                        isDisabled={disableButton}
                        onSpeechBubbleComplete={handleSpeechBubbleComplete}
                    />
                );
            case 2:
                return (
                    <DrawAHeartReady
                        onContinue={handleContinue}
                        isDisabled={disableButton}
                        onSpeechBubbleComplete={handleSpeechBubbleComplete}
                    />
                );
            default:
                return null;
        }
    };

    return renderCurrentState();
};